// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"228":"a99f3517","231":"4f7153f4","379":"7b03279a","634":"171c0d54"}[chunkId] + ".css";
};